import { useEffect, useRef } from 'react';

/** The newest value, readable from an effect or callback that must not re-run when it changes. */
export function useLatest<T>(value: T) {
  const ref = useRef(value);
  useEffect(() => {
    ref.current = value;
  });
  return ref;
}
